import React from 'react';
import Header from '../components/Header';
import Breadcrumb from '../components/Breadcrumb';
import Footer from '../components/Footer';

function Termos() {
  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <Header />
      <Breadcrumb />
      <main className="max-w-4xl mx-auto px-4 py-12">
        <span className="section-kicker">Uso responsável</span>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mt-2 mb-4 text-slate-800">Termos de Uso</h1>
        <p className="text-lg text-gray-600 mb-8">A ferramenta organiza e calcula informações da Escala de Coma de Glasgow. Ela não substitui exame clínico, protocolo institucional ou julgamento profissional.</p>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">Qual é a finalidade da ferramenta?</h2>
          <p className="text-gray-700">Consulta rápida, ensino, documentação estruturada e apoio ao cálculo de O, V e M. O usuário é responsável por avaliar corretamente as respostas observadas e interpretar o resultado no contexto clínico.</p>
        </section>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">O resultado é diagnóstico ou conduta?</h2>
          <p className="text-gray-700">Não. A ECG descreve o nível de consciência observado. O total isolado não define diagnóstico, prognóstico individual ou uma conduta específica. Quando houver componente não testável, o total não deve ser forçado.</p>
        </section>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm mb-6">
          <h2 className="text-2xl font-bold mb-3">Quais limitações precisam ser consideradas?</h2>
          <ul className="space-y-2 text-gray-700">
            <li>• Sedação, intubação, afasia, bloqueio neuromuscular e trauma ocular podem interferir na avaliação.</li>
            <li>• O valor depende da qualidade do exame realizado pelo usuário.</li>
            <li>• Avaliações seriadas e o padrão O/V/M são mais informativos do que um número sem contexto.</li>
            <li>• A disponibilidade do site pode sofrer interrupções técnicas.</li>
          </ul>
        </section>

        <section className="bg-slate-900 text-white rounded-2xl p-6 md:p-8 mb-6">
          <h2 className="text-2xl font-bold text-white mb-3">Como usar de forma segura?</h2>
          <p className="text-slate-100">Confirme os critérios na tabela, registre fatores de interferência, não some componentes NT e use protocolos e recursos locais quando o quadro exigir decisão clínica urgente.</p>
          <a className="underline inline-block mt-3" href="/como-avaliar">Ver como avaliar cada componente</a>
        </section>

        <section className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm">
          <h2 className="text-2xl font-bold mb-3">Contato</h2>
          <p className="text-gray-700">Para relatar erro técnico ou sugerir correção editorial, use o perfil profissional do autor ou acesse as demais ferramentas da Ei Doc.</p>
          <div className="flex flex-wrap gap-4 mt-4 text-sm font-semibold">
            <a className="text-teal-700" href="https://cadu.online">Perfil profissional ↗</a>
            <a className="text-teal-700" href="https://eidoc.com.br/ferramentas">Ei Doc · Ferramentas ↗</a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Termos;
